import { LAYOUTS, } from '@voltmoney/types';
import { WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION, REQUEST_TYPE } from './types';
import { goBackAction, goToDetailsScreen, needHelpAction } from './actions';
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import sharedPropsService from "../../../SharedPropsService";
export const template = (height, pledgeHistoryData, fromInProgressProcess) => {
    return {
        layout: {
            id: ROUTE.PLEDGE_HISTORY,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: true
            },
            widgets: [
                { id: "pledgeHistoryDC", type: WIDGET.PLEDGE_HISTORY }
            ],
        },
        datastore: {
            pledgeHistoryDC: {
                height: height,
                goBackAction: {
                    routeId: ROUTE.PLEDGE_HISTORY,
                    payload: {
                        fromInProgressProcess: fromInProgressProcess
                    },
                    type: ACTION.GO_BACK_ACTION
                },
                needHelpAction: {
                    routeId: ROUTE.PLEDGE_HISTORY,
                    payload: {},
                    type: ACTION.NEED_HELP_ACTION
                },
                pledgeHistoryData: pledgeHistoryData,
                goToDetailsScreenAction: {
                    routeId: ROUTE.PLEDGE_HISTORY,
                    payload: {
                        fromInProgressProcess: fromInProgressProcess
                    },
                    type: ACTION.GO_TO_DETAILS_SCREEN
                },
                fromInProgressProcess: fromInProgressProcess
            },
        }
    };
};
export const pledgeHistoryMF = {
    onLoad: async ({ getHeight, network, removeWidgets }, { fromInProgressProcess }) => {
        await removeWidgets(ROUTE.PLEDGE_HISTORY, [
            { id: "pledgeHistoryDC", type: WIDGET.PLEDGE_HISTORY }
        ]);
        const user = await sharedPropsService.getUser();
        const creditId = user.linkedCredits[0].creditId;
        const getPledgeHistoryResponse = await network.get(`${api.getPledgeHistory}${creditId}?creditRequestTypes=${REQUEST_TYPE.REVOCATION_REQUEST}%2C${REQUEST_TYPE.ENHANCE_LIMIT_REQUEST}`, {
            headers: await getAppHeader(),
        });
        const pledgeHistoryData = getPledgeHistoryResponse?.data;
        const enhanceLimitRequestDetailsList = pledgeHistoryData.enhanceLimitRequestDetailsList;
        const revocationRequestDetailsList = pledgeHistoryData.revocationRequestDetailsList;
        const concatenatedList = enhanceLimitRequestDetailsList.concat(revocationRequestDetailsList);
        const sortedList = concatenatedList.sort((a, b) => {
            const timestampA = a.createdOn;
            const timestampB = b.createdOn;
            return timestampB - timestampA;
        });
        return Promise.resolve(template(getHeight(), sortedList, fromInProgressProcess));
    },
    actions: {
        [ACTION.GO_BACK_ACTION]: goBackAction,
        [ACTION.NEED_HELP_ACTION]: needHelpAction,
        [ACTION.GO_TO_DETAILS_SCREEN]: goToDetailsScreen,
    },
};
